export default __webpack_public_path__ + "static/media/fruit.f7b6dbd5.jpg";